import "./Skills.css"
import { FaHtml5, FaCss3Alt, FaJs, FaReact, FaGitAlt, FaGithub } from "react-icons/fa"
import { SiNextdotjs, SiTailwindcss } from "react-icons/si"

const Skills = () => {
    return (
        <section className="skills section" id="skills">
            <h2 className="section__title">My Skills</h2>
            <span className="section__subtitle">My Technical Level</span>

            <div className="skills__container container grid">
                {/* HTML */}
                <div className=" skills__content">
                    <FaHtml5 className="skills__icon" color="#e44d26" />
                    <h3 className="skills__name">HTML</h3>
                </div>

                {/* CSS */}
                <div className=" skills__content">
                    <FaCss3Alt className="skills__icon" color="#264de4" />
                    <h3 className="skills__name">CSS</h3>
                </div>

                {/* JavaScript */}
                <div className="skills__content">
                    <FaJs className="skills__icon" color="#f0db4f" />
                    <h3 className="skills__name">JavaScript</h3>
                </div>

                {/* React */}
                <div className=" skills__content">
                    <FaReact className="skills__icon" color="#61DBFB" />
                    <h3 className="skills__name">React JS</h3>
                </div>

                {/* Next.js */}
                <div className=" skills__content">
                    <SiNextdotjs className="skills__icon" color="#000000" />
                    <h3 className="skills__name">Next JS</h3>
                </div>

                {/* Tailwind CSS */}
                <div className=" skills__content">
                    <SiTailwindcss className="skills__icon" color="#38BDF8" />
                    <h3 className="skills__name">Tailwind CSS</h3>
                </div>

                {/* Git */}
                <div className=" skills__content">
                    <FaGitAlt className="skills__icon" color="#F1502F" />
                    <h3 className="skills__name">Git</h3>
                </div>

                {/* GitHub */}
                <div className=" skills__content">
                    <FaGithub className="skills__icon" color="#000000" />
                    <h3 className="skills__name">GitHub</h3>
                </div>
            </div>
        </section>
    )
}

export default Skills
